import { controllers } from '../../Controllers/Controller'
import { HomePageModel } from '../../Controllers/PageControllers/HomePageModel'
import { photosource } from '../../Helpers/Feathure'
import { MainCarousel } from '../design/MainCarousel'
import { WowCarousel } from '../design/WowCarousel'
import { WowDestiny } from '../design/WowDestiny'
import { WowText } from '../design/WowText'
import { PageView } from './PageView'
import {ReviewList} from "../design/ReviewList";
import {navigator} from "../../Controllers/Navigator";
import {AboutPage} from "../Components/AboutBlock/AboutBlock";
import {RecentProjects} from "../Components/RecentProjects/RecentProjects";
import {StartJourneySection} from "../Components/StartJourneySection/StartJourneySection";

class HomePage extends PageView {
    componentDidMount(){
        super.componentDidMount()
        // navigator().navigate('/car-builder')
    }

    get controller():HomePageModel{
        return this.props.controller
    }

    render(){
        return <div className="home page">
            <MainCarousel
                videos={[
                    '/videos/1.webm',
                    '/videos/2.webm',
                ]}
                photos={[photosource("ppeVNG85v4Jo"), photosource("FZl6Zz1X6VQ0"), photosource("vEFW20MmUZvc"), photosource("gRGzQr70OPNY")]}
                title="SINCE 2006"
                description='Classic & Sportscar Restorations'
            />
            <WowText
                title='COMMITTED TO UNCOMPROMISING QUALITY'
            >
                Chobal is a team of people dedicated to transforming past achievements into a brighter future - driven by a constant desire to improve and restore the best models of classic cars
            </WowText>
            <WowCarousel photos={[photosource("XUw8TGggOSPk"), photosource("DFykil1N6ZIQ"), photosource("p4aKCirVN7Zm"),photosource("AVgrZtP5pgyA")]}/>
            <AboutPage />
            <WowText
                title='EVERY DETAIL MATTERS'
            >
                Achieving our mission's success demands a distinctive approach, with every detail-no matter how minor-being carefully optimized to ensure excellence
            </WowText>
            <WowCarousel photos={[photosource("S1wZSYXIrVFh"),photosource("7tQUSpLFaWry"),photosource("4Q1fUduuUMEZ"), photosource("qTy2Xl1vCyWq")]}/>
            <RecentProjects />
            <WowDestiny
                title="EXCELLENCE IN EVERY DECISION"
                click={controllers().menu.rightToggle}
                photos={[photosource("l3uCMT9sIShN")]}
            >
                Our distinct perspective fosters exclusive partnerships. We work closely with each owner to prioritize what truly matters to them.
            </WowDestiny>
            <StartJourneySection />
            <ReviewList />
        </div>
    }
}

export { HomePage }
